import { render, staticRenderFns } from "./statusHolder.vue?vue&type=template&id=4cb35891&"
import script from "./statusHolder.vue?vue&type=script&lang=js&"
export * from "./statusHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports